export default {
  STAFF: 5,
  ADMIN: 10,
}



// WEBPACK FOOTER //
// ./src/consts/StaffRole.js